/* unplugin-vue-components disabled */import script from "./PointsExamine.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsExamine.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__